module.exports = __webpack_public_path__ + "img/Login3.248ae2cf.svg";